import * as React from "react";
import { forwardRef } from "react";
const SvgIconBook = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 20, viewBox: "0 0 16 20", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", fillRule: "evenodd", d: "M14 0H2C.9 0 0 .9 0 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2ZM5 2h2v5l-1-.75L5 7V2Zm9 16H2V2h1v9l3-2.25L9 11V2h5v16Z" }));
const ForwardRef = forwardRef(SvgIconBook);
export default ForwardRef;
